import React, { FC } from 'react';
import cn from 'classnames';
import { EngineTheme, useMergeClasses, useTheme } from '../../../../../../theme';
import Filter from '../../../Filter/ui/Filter';
import { SegmentTabType } from '../../model/types';
import { CdnIcon } from '@shared/ui/CdnIcon';
import { buildDataAttributes } from '@shared/lib/dom';
import { useMediaQuery } from 'react-responsive';

interface Props {
	classes?: EngineTheme['Shared']['SegmentTabs']['SegmentTab'];

	segment: SegmentTabType;
	index: number;
	count?: number;
	isActive: boolean;
	isCompact: boolean;

	onClick: () => void;
}

const SegmentTab: FC<Props> = ({ classes, isCompact, isActive, index, segment, count, onClick }) => {
	const { SegmentTab: defaultClasses } = useTheme('Shared').SegmentTabs;
	const css = useMergeClasses(defaultClasses, classes);

	const isSmallMobile = useMediaQuery({ maxWidth: 400 });

	const { isDisabled, isChecked, additional, title } = segment;

	const showIndex = isSmallMobile || (isCompact && !isActive);
	const showAdditional = additional && !showIndex;

	const label = showIndex ? index : title;

	const LabelElement = (
		<span className={css.label}>
			{label}
			{showAdditional && (
				<>
					<span className={css.dot} />
					{additional}
				</>
			)}
		</span>
	);

	return (
		<div className={cn(css.root, { [css.active]: isActive, [css.disabled]: isDisabled })}>
			{isChecked && (
				<div className={css.checkedIcon}>
					<CdnIcon icon="Info/Item Icluded" />
				</div>
			)}

			<Filter
				size="large"
				color="gray"
				label={LabelElement}
				isDisabled={isDisabled}
				isSelected={isActive}
				quantity={count || undefined}
				onClick={onClick}
				dataTestId="segment-tab"
				dataAttributes={buildDataAttributes({
					'segment-id': segment.id,
					'segment-active': isActive,
					'segment-disabled': isDisabled,
					'seats-count': count
				})}
			/>
		</div>
	);
};

export default SegmentTab;
